import { Box, FsCircularProgress, FsProgress, FsTypography } from "@aviatrix/flights";
import React from "react";

type SizeType = 'small' | 'large'
type alignType = 'left' | 'center' | 'right'
type InProgessProps = {
    show:boolean,
    text:string,
    desc?:string,
    size?:SizeType,
    textAlign?:alignType,
    color?:string
}

const InProcess = ({show = false, text, desc, size='small', textAlign='center' }:InProgessProps)=>{
    
    return (
        <>
            {show && 
            <Box 
                display="flex" 
                flexDirection="column" 
                alignItems={ textAlign}
                justifyContent="center" 
                gap={0} mt={2}
            >
                <Box 
                    display="flex" 
                    flexDirection="row" 
                >
                    <FsCircularProgress thickness={5}  size={20}  />
                    <FsTypography variant={size==='small'?'h5':'h3'} pl={1}>{text}</FsTypography>
                </Box>
                {desc && 
                    <Box pl={(textAlign=="center"?0:'30px')} textAlign={textAlign}>
                        <FsTypography variant={size==='small'?'tiny':'caption'}>{desc}</FsTypography>
                    </Box>
                }
            </Box> 
            }
        </>
    )
}

export default InProcess;